import config from './env-config.json';

/*******************************************************************************
 * env-config.js includes environment configuration for the app
 ******************************************************************************/

export interface IConfigLeaf {
  environment: string;
  envPrefix: string;
  envSuffix: string;
  gatewayApi: string;
  isLocal?: boolean;
  isProd?: boolean;
  launchDarklyClientId: string;
  upEnvironment: string;
  universalNavEnvKey: string;
}

/**
 * @type {EnvironmentConfig}
 */
const envConfig: IConfigLeaf = config[
  window.location.hostname as keyof typeof config
] as IConfigLeaf;
envConfig.isProd = envConfig.upEnvironment === 'PRODUCTION';
envConfig.isLocal = envConfig.upEnvironment === 'LOCAL';

/*******************************************************************************
 * exported api definition
 ******************************************************************************/
export default envConfig;
